import { render, staticRenderFns } from "./Modify.vue?vue&type=template&id=c10f434c&scoped=true&"
import script from "./Modify.vue?vue&type=script&lang=js&"
export * from "./Modify.vue?vue&type=script&lang=js&"
import style0 from "./Modify.vue?vue&type=style&index=0&lang=less&"
import style1 from "./Modify.vue?vue&type=style&index=1&id=c10f434c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c10f434c",
  null
  
)

export default component.exports